import { render, staticRenderFns } from "./AffiliateReferralsPage.vue?vue&type=template&id=08c3ce5d&scoped=true&lang=pug&"
import script from "./AffiliateReferralsPage.vue?vue&type=script&lang=js&"
export * from "./AffiliateReferralsPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateReferralsPage.vue?vue&type=style&index=0&id=08c3ce5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3ce5d",
  null
  
)

export default component.exports